export default __webpack_public_path__ + "static/exit_img-620242042d8276b84572390a1dd5e35f.svg";